import { checkBoxChanged } from '@job-facets/redux/jobsFilterSlice';
/**
 * Executes when popular tags lists are clicked
 * @param {string} type
 * @param {string} value
 * @param {array} activeItems
 * @param {function} setActiveItems
 * @returns {void}
 */
function PopularTagsClicked(
	value,
	activeItems,
	setActiveItems,
	dispatch,
	slug,
) {
	// if value exists inside the activeItems array, then remove it from the array
	// if the value doesnt exist inside the activeItems array, then add it to the array
	if (activeItems.includes(value)) {
		const filteredItems = activeItems.filter((item) => item !== value);
		setActiveItems(filteredItems);
	} else {
		setActiveItems([...activeItems, value]);
	}

	// using checkboxChanged redux method here as it fits the use case
	dispatch(checkBoxChanged({ value, slug }));
}

export default PopularTagsClicked;
